export { GenericProperties } from './GenericProperties';
